import axios from "axios";

// Get token and user ID from localStorage
const getToken = () => localStorage.getItem("token");
const getUserId = () => localStorage.getItem("user_id");

// Create an Axios instance
const axiosInstance = axios.create({
    baseURL: "https://apierp.unplannedholiday.in",
    withCredentials: true,
});

// ✅ Request Interceptor — always attach the latest token before every request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor (Handles Token Refresh)
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Extensive error logging
        console.log('Interceptor Error:', {
            status: error.response?.status,
            data: error.response?.data,
            headers: error.response?.headers,
            originalRequest: originalRequest
        });

        // Handle network errors
        if (!error.response) {
            console.error("Network error or server not responding:", error);
            return Promise.reject(error);
        }

        // More flexible token expiration check
        const isTokenExpired = 
            error.response.status === 401 || 
            error.response.data?.error?.includes('token') || 
            error.response.data?.error?.includes('expired');

        // Check if this is a retry attempt
        if (isTokenExpired && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                console.log("Attempting to refresh token...");

                const user_id = { userId: getUserId() };
                
                const refreshResponse = await axios.post(
                    "https://apierp.unplannedholiday.in/auth/gettoken", 
                    user_id, 
                    { headers: { 'Content-Type': 'application/json' } }
                );

                console.log('Refresh Token Response:', refreshResponse.data);

                if (!refreshResponse.data.refreshToken) {
                    throw new Error("No refresh token received");
                }

                const tokenResponse = await axios.post(
                    "https://apierp.unplannedholiday.in/auth/refresh-token", 
                    { refreshToken: refreshResponse.data.refreshToken }, 
                    { headers: { 'Content-Type': 'application/json' } }
                );

                console.log('New Token Response:', tokenResponse.data);

                if (!tokenResponse.data.accessToken) {
                    throw new Error("No new access token received");
                }

                // Save new access token
                localStorage.setItem("token", tokenResponse.data.accessToken);

                // Update original request with new token and retry
                originalRequest.headers["Authorization"] = `Bearer ${tokenResponse.data.accessToken}`;
                return axiosInstance(originalRequest);

            } catch (refreshError) {
                console.error("Token Refresh Failed:", refreshError);
                
                localStorage.removeItem("token");
                localStorage.removeItem("user_id");
                window.location.href = "/login";
                
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;